// extracted by mini-css-extract-plugin
export default {"bg_image":"NotFound_bg_image__miKUP","title":"NotFound_title__D8KzW","btn":"NotFound_btn__i6AKB"};